module.exports = __webpack_public_path__ + "img/airdrop.93de13f2.svg";